module.exports = __webpack_public_path__ + "media/images/5_help-c1e30df6d4923987744404f3c097aec3.jpg";